module.exports = __webpack_public_path__ + "static/media/ID.1b1f8211.svg";